export const CurrencyMap = {
  GET_ALL_CURRENCY_START: "GET_ALL_CURRENCY_START",
  GET_ALL_CURRENCY_SUCCESS: "GET_ALL_CURRENCY_SUCCESS",
  GET_ALL_CURRENCY_ERROR: "GET_ALL_CURRENCY_ERROR",
  ADD_CURRENCY_START: "ADD_CURRENCY_START",
  ADD_CURRENCY_SUCCESS: "ADD_CURRENCY_SUCCESS",
  ADD_CURRENCY_ERROR: "ADD_CURRENCY_ERROR",
  SELECT_USER_DETAILS: "SELECT_USER_DETAILS",
  COUNTRY_FILTERS: "COUNTRY_FILTERS",
  APPLY_FILTERS: "APPLY_FILTERS",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  REFRESH_CURRENCY_LIST: "REFRESH_CURRENCY_LIST",
  SET_CURRENCY_BATCH_NUMBER: "SET_CURRENCY_BATCH_NUMBER",
  SELECT_CURRENCY_DETAILS: "SELECT_CURRENCY_DETAILS",
  GET_ALL_TEMPLATES_START: "GET_ALL_TEMPLATES_START",
  GET_ALL_TEMPLATES_SUCCESS: "GET_ALL_TEMPLATES_SUCCESS",
  GET_ALL_TEMPLATES_ERROR: "GET_ALL_TEMPLATES_ERROR",
  UPDATE_CURRENCY_START: "UPDATE_CURRENCY_START",
  UPDATE_CURRENCY_SUCCESS: "UPDATE_CURRENCY_SUCCESS",
  UPDATE_CURRENCY_ERROR: "UPDATE_CURRENCY_ERROR",
  DELETE_CURRENCY_START: "DELETE_CURRENCY_START",
  DELETE_CURRENCY_SUCCESS: "DELETE_CURRENCY_SUCCESS",
  DELETE_CURRENCY_ERROR: "DELETE_CURRENCY_ERROR",
};

export const CurrencyActions = {
  getAllCurrencyStart: (data) => ({
    type: CurrencyMap.GET_ALL_CURRENCY_START,
    payload: data,
  }),
  getAllCurrencySuccess: (data) => ({
    type: CurrencyMap.GET_ALL_CURRENCY_SUCCESS,
    payload: data,
  }),
  getAllCurrencyError: (errors) => ({
    type: CurrencyMap.GET_ALL_CURRENCY_ERROR,
    payload: { errors },
  }),
  deleteCurrencyStart: (data) => ({
    type: CurrencyMap.DELETE_CURRENCY_START,
    payload: data,
  }),
  deleteCurrencySuccess: (data) => ({
    type: CurrencyMap.DELETE_CURRENCY_SUCCESS,
    payload: data,
  }),
  deleteCurrencyError: (errors) => ({
    type: CurrencyMap.DELETE_CURRENCY_ERROR,
    payload: { errors },
  }),
  addCurrencyStart: (data) => ({
    type: CurrencyMap.ADD_CURRENCY_START,
    payload: data,
  }),
  addCurrencySuccess: (data) => ({
    type: CurrencyMap.ADD_CURRENCY_SUCCESS,
    payload: data,
  }),
  addCurrencyError: (errors) => ({
    type: CurrencyMap.ADD_CURRENCY_ERROR,
    payload: { errors },
  }),
  updateCurrencyStart: (data) => ({
    type: CurrencyMap.UPDATE_CURRENCY_START,
    payload: data,
  }),
  updateCurrencySuccess: (data) => ({
    type: CurrencyMap.UPDATE_CURRENCY_SUCCESS,
    payload: data,
  }),
  updateCurrencyError: (errors) => ({
    type: CurrencyMap.UPDATE_CURRENCY_ERROR,
    payload: { errors },
  }),
  getCurrencyTemplateStart: (data) => ({
    type: CurrencyMap.GET_ALL_TEMPLATES_START,
    payload: data,
  }),
  getCurrencyTemplateSuccess: (data) => ({
    type: CurrencyMap.GET_ALL_TEMPLATES_SUCCESS,
    payload: data,
  }),
  getCurrencyTemplateError: (errors) => ({
    type: CurrencyMap.GET_ALL_TEMPLATES_ERROR,
    payload: { errors },
  }),
  applyFilters: (data) => ({
    type: CurrencyMap.APPLY_FILTERS,
    payload: data,
  }),
  refreshCurrencyList: () => ({
    type: CurrencyMap.REFRESH_CURRENCY_LIST,
  }),
  searchTextChange: (data) => ({
    type: CurrencyMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setSelectedCurrency: (data) => ({
    type: CurrencyMap.SELECT_CURRENCY_DETAILS,
    payload: data,
  }),
  setCurrencyBatchNumber: (data) => ({
    type: CurrencyMap.SET_CURRENCY_BATCH_NUMBER,
    payload: data,
  }),
};
